<template>
  <div>
    <button
      v-if="collapsible"
      class="btn-toggle"
      @click="toggle"
    >
      <span v-if="isOpen">▾ {{ $t('instructions.hide') }}</span>
      <span v-else>▸ {{ $t('instructions.show') }}</span>
    </button>

    <transition name="fade">
      <ul v-show="!collapsible || isOpen" class="instructionList">
        <li v-if="publication.access === 'multiple'">☑️ {{ $t('instructions.multipleAccess') }}</li>
        <li v-if="publication.access === 'unique'">🔑 {{ $t('instructions.singleAttempt') }}</li>
        <li v-if="publication.timeLimit === true">⏱️ {{ $t('instructions.timeLimited', { minutes: formattedDuration }) }}</li>
        <li v-if="publication.skip === true">🚶‍♀️ {{ $t('instructions.skipAllowed') }}</li>
        <li v-if="publication.skip === false">✋️ {{ $t('instructions.noSkip') }}</li>
        <li v-if="publication.browsing === 'backPossible'">🔙 {{ $t('instructions.backPossible') }}</li>
        <li v-if="publication.browsing === 'noBack'">⛔ {{ $t('instructions.noBack') }}</li>
        <li v-if="publication.testMap === true">🗺️ {{ $t('instructions.testMap') }}</li>
        <li v-if="publication.readOnlyAnswer">👓 {{ $t('instructions.readOnly') }}</li>
        <li v-if="publication.revealQuestionNB === true">🧮 {{ $t('instructions.totalQuestions', { count: totalQuestions }) }}</li>
        <!-- Instructions spécifiques pour les tests adaptatifs (CAT) -->
        <li v-if="isAdaptiveTest">🐈 {{ $t('instructions.adaptiveTest') }}</li>
        <li v-if="isAdaptiveTest">🎯 {{ $t('instructions.adaptiveLogic') }}</li>
        <li v-if="isAdaptiveTest">📊 {{ $t('instructions.adaptiveProgress') }}</li>
        <!-- Instructions spécifiques pour les tests conditionnels -->
        <li v-if="isConditionalTest"> 🔀 {{ $t('instructions.conditionalTest') }}</li>
       
      </ul>
    </transition>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';

const props = defineProps({
  publication: { type: Object, required: true },
  collapsible: { type: Boolean, default: true }
});

const formattedDuration = computed(() => {
  const minutes = Number(props.publication?.testId?.duration) || 0
  const totalSeconds = minutes * 60
  const hh = String(Math.floor(totalSeconds / 3600)).padStart(2, '0')
  const mm = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, '0')
  const ss = String(totalSeconds % 60).padStart(2, '0')
  return `${hh}:${mm}:${ss}`
})

const isOpen = ref(true);

console.log(props.publication.testId?.duration)


if (props.collapsible) {
  isOpen.value = false;
}

// Computed property pour compter seulement les vraies questions (exclut les messages)
const totalQuestions = computed(() => {
  if (!props.publication?.testId?.elements) {
    return 0;
  }
  
  return props.publication.testId.elements.filter(element => 
    element.el_Type !== 'message'
  ).length;
});

// Computed property pour détecter les tests adaptatifs (CAT)
const isAdaptiveTest = computed(() => {
  return props.publication.progressionType === 'adaptive';
});

// Computed property pour détecter les tests conditionnels
const isConditionalTest = computed(() => {
  return props.publication.progressionType === 'conditional';
});


const toggle = () => {
  isOpen.value = !isOpen.value;
};
</script>

<style scoped>
.btn-toggle {
  background: none;
  border: none;
  color: #007bff;
  cursor: pointer;
  padding: 0.25rem;
}
.instructionList {
  margin-top: 0.5rem;
  padding-left: 1.2rem;
  list-style-type: none;
  padding-left: 10px;
  margin-left: 0;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>